const memoizeWeak = fn => {
  if (typeof WeakMap === 'undefined') {
    return fn;
  }
  const cache = new WeakMap();
  return obj => {
    if (cache.has(obj)) {
      return cache.get(obj);
    }
    const result = fn(obj);
    cache.set(obj, result);
    return result;
  };
};
export default memoizeWeak;